import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const useOTBookings = () => {
  const [otBookings, setOtBookings] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const fetchOTBookings = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(`${API_BASE_URL}/get_ot_bookings`, { withCredentials: true });
      const data = response.data?.ot_bookings;
      if (Array.isArray(data)) {
        setOtBookings(data);
        setFilteredRows(data);
      } else {
        setError('Invalid data from server');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to fetch OT bookings');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOTBookings();
  }, []);

  const deleteBooking = async (uhid_no) => {
    try {
      const resp = await axios.delete(`${API_BASE_URL}/delete_ot_booking_by_uhid/${uhid_no}`);
      if (resp.status === 200) {
        setOtBookings(prev => prev.filter(b => b.uhid_no !== uhid_no));
        setFilteredRows(prev => prev.filter(b => b.uhid_no !== uhid_no));
        setSuccessMessage('Booking deleted successfully');
        setTimeout(() => setSuccessMessage(''), 3000);
        return true;
      }
      return false;
    } catch (err) {
      console.error(err);
      setError('Error deleting booking');
      return false;
    }
  };

  return {
    otBookings,
    filteredRows,
    setFilteredRows,
    loading,
    error,
    setError,
    successMessage,
    setSuccessMessage,
    deleteBooking,
    refreshBookings: fetchOTBookings
  };
};
